var _path, _circle, _path2, _path3, _path4, _g, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 28c.05-.66.09-1.33.09-2a27.763 27.763 0 0 0-.44-5.03 25.552 25.552 0 0 0-2.5-7.51A22.381 22.381 0 0 0 29 3a32.934 32.934 0 0 1 24.98 13.11 27.4 27.4 0 0 1 3.75 6.91A24.754 24.754 0 0 1 59 28z",
    fill: "#d9176c"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 6,
    fill: "#9b1e5a",
    r: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32a29 29 0 0 1-29 29A28.275 28.275 0 0 1 3 44a23.765 23.765 0 0 0 17 7 25.076 25.076 0 0 0 4.75-.46 18.565 18.565 0 0 0 1.99-.46A23.934 23.934 0 0 0 32 48l-3-6h9.98A25.326 25.326 0 0 0 44 32z",
    fill: "#f9bb4b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 45a5.006 5.006 0 0 1-5-5h2a3 3 0 0 0 6 0h2a5.006 5.006 0 0 1-5 5zM37 54.11a15.652 15.652 0 0 1-4.9.89c-5.42 0-7.14-3.93-7.35-4.46a18.565 18.565 0 0 0 1.99-.46c.46.97 2.66 4.46 9.63 2.13z",
    fill: "#394d5c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.73 23.02a3.951 3.951 0 0 1-2.43.84 3.985 3.985 0 0 1-1.32-7.75 27.4 27.4 0 0 1 3.75 6.91zM45.84 17.06a4 4 0 0 1-3.19 3.91 25.552 25.552 0 0 0-2.5-7.51 3.824 3.824 0 0 1 1.69-.4 4.005 4.005 0 0 1 4 4z",
    fill: "#eb8cb3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7fcac9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 42h-5a1 1 0 0 1-.707-1.707L17.586 37H15a1 1 0 0 1 0-2h5a1 1 0 0 1 .707 1.707L17.414 40H20a1 1 0 0 1 0 2zM33 32h-6a1 1 0 0 1-.707-1.707L30.586 26H27a1 1 0 0 1 0-2h6a1 1 0 0 1 .707 1.707L29.414 30H33a1 1 0 0 1 0 2zM22 22h-8a1 1 0 0 1-.707-1.707L19.586 14H14a1 1 0 0 1 0-2h8a1 1 0 0 1 .707 1.707L16.414 20H22a1 1 0 0 1 0 2z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28h20v4H41z",
    fill: "#6f1d48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.f43c67a800e2c0181aa454dee2444f98.svg";
export { ForwardRef as ReactComponent };